class TripModel {
  readonly tripTitle: string;
  readonly createdOn: string;
  readonly id: number;
  readonly fio: string;
  readonly phone: string;
  readonly startDate: string;
  readonly endDate: string;
  readonly addressFrom: string;
  readonly addressTo: string;
  readonly transportType: string;
  readonly price: string;
  readonly baggageType: Array<string>;
  readonly tripStatus: string;
  readonly tripType: string;
  readonly offerSum: string;
  readonly offerFio: string;
  readonly payment: string;
  readonly unvisable: string;
  readonly phoneNumberOffer: string;
  readonly isActual: boolean;
  readonly fromPlaceId: string;
  readonly toPlaceId: string;
  readonly shifter: string;
  readonly canDelete: boolean;

  constructor({
    tripTitle,
    createdOn,
    id,
    fio,
    phone,
    startDate,
    endDate,
    addressFrom,
    addressTo,
    transportType,
    price,
    baggageType,
    tripStatus,
    tripType,
    offerSum,
    offerFio,
    payment,
    unvisable,
    phoneNumberOffer,
    isActual,
    fromPlaceId,
    toPlaceId,
    shifter,
    canDelete
  }) {
    this.tripTitle = tripTitle;
    this.createdOn = createdOn;
    this.id = id;
    this.fio = fio;
    this.phone = phone;
    this.startDate = startDate;
    this.endDate = endDate;
    this.addressFrom = addressFrom;
    this.addressTo = addressTo;
    this.transportType = transportType;
    this.price = price;
    this.baggageType = baggageType;
    this.tripStatus = tripStatus;
    this.tripType = tripType;
    this.offerSum = offerSum;
    this.offerFio = offerFio;
    this.payment = payment;
    this.unvisable = unvisable;
    this.phoneNumberOffer = phoneNumberOffer;
    this.isActual = isActual;
    this.fromPlaceId = fromPlaceId;
    this.toPlaceId = toPlaceId;
    this.shifter = shifter;
    this.canDelete = canDelete;
  }
}

export default TripModel
